import { useState } from "react";
import { categories } from "../../../mocks/starTracker";

export default function Types() {
  const [active, setActive] = useState(categories[0].id);
  const current = categories.find((c) => c.id === active) || categories[0];

  return (
    <section id="types" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-700">
              <i className="ri-node-tree text-base"></i>
              后续形态
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              事件走向，从来不是一句“官宣”就结束
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              我们把明星婚变后最常见的几种后续形态分开梳理——看懂每一条线，就能定位事件当前所处的位置。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="grid grid-cols-1 gap-2.5 sm:grid-cols-2 lg:grid-cols-1">
              {categories.map((c) => (
                <button
                  key={c.id}
                  type="button"
                  onClick={() => setActive(c.id)}
                  aria-pressed={active === c.id}
                  className={`group flex items-center gap-3 rounded-md px-4 py-3.5 text-left transition-all ${
                    active === c.id
                      ? "bg-primary-600 text-background-50 shadow-none"
                      : "bg-secondary-100 text-foreground-800 hover:bg-secondary-200"
                  }`}
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md ${
                      active === c.id ? "bg-background-50/15" : "bg-background-50 text-primary-700"
                    }`}
                  >
                    <i className={`${c.icon} text-lg`}></i>
                  </span>
                  <span className="min-w-0">
                    <span className="block text-sm font-bold whitespace-nowrap">{c.name}</span>
                    <span className={`block text-xs ${active === c.id ? "text-background-200" : "text-secondary-600"} whitespace-nowrap`}>
                      {c.count}
                    </span>
                  </span>
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="relative flex h-full flex-col overflow-hidden rounded-lg bg-foreground-950 p-6 md:p-8">
              <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-600/30 blur-2xl"></div>
              <div className="pointer-events-none absolute -bottom-16 -left-10 h-48 w-48 rounded-full bg-accent-500/20 blur-2xl"></div>
              <div className="relative">
                <div className="flex items-center gap-3">
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500/25 text-accent-300">
                    <i className={`${current.icon} text-xl`}></i>
                  </span>
                  <h3 className="font-heading text-xl font-black text-background-50 md:text-2xl">{current.name}</h3>
                </div>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200/90 md:text-base">
                  {current.desc}
                </p>
                <ul className="mt-6 space-y-3">
                  {current.points.map((p) => (
                    <li
                      key={p}
                      className="flex items-center gap-3 rounded-md bg-background-50/[0.06] px-4 py-3 text-sm text-background-100 ring-1 ring-background-50/10"
                    >
                      <i className="ri-checkbox-circle-line text-accent-300"></i>
                      {p}
                    </li>
                  ))}
                </ul>
                <div className="mt-7 flex flex-wrap items-center gap-3">
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-500"
                  >
                    查看该线最新进展 <i className="ri-arrow-right-line"></i>
                  </button>
                  <button
                    type="button"
                    className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50/10 px-5 py-2.5 text-sm font-semibold text-background-50 ring-1 ring-background-50/20 transition-colors hover:bg-background-50/20"
                  >
                    相关复盘合集
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}